export default {
  // /*!
  //  * Web Fonts from Fontspring.com
  //  *
  //  * All OpenType features and all extended glyphs have been removed.
  //  * Fully installable fonts can be purchased at http://www.fontspring.com
  //  *
  //  * The fonts included in this stylesheet are subject to the End User License you purchased
  //  * from Fontspring. The fonts are protected under domestic and international trademark and
  //  * copyright law. You are prohibited from modifying, reverse engineering, duplicating, or
  //  * distributing this font software.
  //  *
  //  * (c) 2010-2018 Fontspring
  //  *
  //  *
  //  *
  //  *
  //  * The fonts included are copyrighted by the vendor listed below.
  //  *
  //  * Vendor:      Fontfabric
  //  * License URL: https://www.fontspring.com/licenses/fontfabric/webfont
  //  *
  //  *
  //  */

  '@font-face': [
    {
      fontFamily: 'Mont',
      src: [
        'url("/fonts/MontHeavy/mont-heavy-webfont.woff2") format("woff2")',
        'url("/fonts/MontHeavy/mont-heavy-webfont.woff") format("woff")'
      ],
      fontWeight: 900,
      fontStyle: 'normal'
    },
    {
      fontFamily: 'Mont',
      src: [
        'url("/fonts/MontHeavy/mont-bold-webfont.woff2") format("woff2")',
        'url("/fonts/MontHeavy/mont-bold-webfont.woff") format("woff")'
      ],
      fontWeight: 700,
      fontStyle: 'normal'
    },
    // /*!
    //  * Web Fonts from Fontspring.com
    //  *
    //  * All OpenType features and all extended glyphs have been removed.
    //  * Fully installable fonts can be purchased at http://www.fontspring.com
    //  *
    //  * The fonts included in this stylesheet are subject to the End User License you purchased
    //  * from Fontspring. The fonts are protected under domestic and international trademark and
    //  * copyright law. You are prohibited from modifying, reverse engineering, duplicating, or
    //  * distributing this font software.
    //  *
    //  * (c) 2010-2018 Fontspring
    //  *
    //  *
    //  *
    //  *
    //  * The fonts included are copyrighted by the vendor listed below.
    //  *
    //  * Vendor:      exljbris Font Foundry
    //  * License URL: https://www.fontspring.com/licenses/exljbris/webfont
    //  *
    //  *
    //  */
    {
      fontFamily: 'MuseoSans',
      src: [
        'url("/fonts/MuseoSans/MuseoSans_500-webfont.woff2") format("woff2")',
        'url("/fonts/MuseoSans/MuseoSans_500-webfont.woff") format("woff")'
      ],
      fontWeight: 500,
      fontStyle: 'normal'
    },
    {
      fontFamily: 'MuseoSans',
      src: [
        'url("/fonts/MuseoSans/MuseoSans_700-webfont.woff2") format("woff2")',
        'url("/fonts/MuseoSans/MuseoSans_700-webfont.woff") format("woff")'
      ],
      fontWeight: 700,
      fontStyle: 'normal'
    },

    // // BP-mono Freely distributed at http://backpacker.gr/fonts/5
    {
      fontFamily: 'BPmono',
      src: 'url("/fonts/BPmono/BPmono.ttf") format("truetype")',
      fontWeight: 500,
      fontStyle: 'normal'
    }
  ]
}
